export default __webpack_public_path__ + "fd1add9ceb3f8eeb4e28cc3239c520b5.png";